import { render, staticRenderFns } from "./BlockStats.vue?vue&type=template&id=345bedf9&"
import script from "./BlockStats.vue?vue&type=script&lang=js&"
export * from "./BlockStats.vue?vue&type=script&lang=js&"
import style0 from "./BlockStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports